import React from 'react';
import { Box, Grid, Paper, Divider, Skeleton } from '@mui/material';

const ProfileSkeleton = () => {
  return (
    <Box className="profile-container" sx={{ p: 4, maxWidth: '1200px', margin: '0 auto' }}>
      <Grid container spacing={3}>
        {/* Images Section */}
        <Grid item xs={12} md={6}>
          <Skeleton variant="text" width={120} height={24} animation="wave" sx={{ mb: 1.5 }} />
          <Paper
            elevation={0}
            sx={{
              p: 3,
              height: '250px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              border: '2px dashed #E0E0E0',
              borderRadius: '4px',
              gap: 1.5,
            }}
          >
            <Skeleton variant="circular" width={80} height={80} animation="wave" />
            <Skeleton variant="text" width={160} height={20} animation="wave" />
            <Skeleton variant="text" width={220} height={16} animation="wave" />
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Skeleton variant="text" width={120} height={24} animation="wave" sx={{ mb: 1.5 }} />
          <Paper
            elevation={0}
            sx={{
              p: 3,
              height: '250px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              border: '2px dashed #E0E0E0',
              borderRadius: '4px',
              gap: 1.5,
            }}
          >
            <Skeleton variant="rectangular" width="80%" height={100} animation="wave" sx={{ borderRadius: '6px' }} />
            <Skeleton variant="text" width={200} height={16} animation="wave" />
          </Paper>
        </Grid>

        {/* Restaurant Info Section */}
        {Array.from({ length: 8 }).map((_, idx) => (
          <Grid item xs={12} md={6} key={idx} sx={{ mt: idx < 2 ? 2 : 0 }}>
            <Skeleton variant="text" width={130} height={20} animation="wave" sx={{ mb: 0.5 }} />
            <Skeleton variant="rectangular" height={40} animation="wave" sx={{ borderRadius: '8px' }} />
          </Grid>
        ))}

        {/* Bio */}
        <Grid item xs={12} md={6}>
          <Skeleton variant="text" width={130} height={20} animation="wave" sx={{ mb: 0.5 }} />
          <Skeleton variant="rectangular" height={80} animation="wave" sx={{ borderRadius: '8px' }} />
        </Grid>

        {/* Location Details Section */}
        <Grid item xs={12} sx={{ mt: 2 }}>
          <Skeleton variant="text" width={160} height={32} animation="wave" sx={{ mb: 1 }} />
          <Divider sx={{ mb: 1 }} />
        </Grid>

        {/* Premises Name */}
        <Grid item xs={12}>
          <Skeleton variant="text" width={140} height={20} animation="wave" sx={{ mb: 0.5 }} />
          <Skeleton variant="rectangular" height={40} animation="wave" sx={{ borderRadius: '8px' }} />
        </Grid>

        {/* Location Fields */}
        {Array.from({ length: 8 }).map((_, idx) => (
          <Grid item xs={12} md={6} key={`loc-${idx}`}>
            <Skeleton variant="text" width={120} height={20} animation="wave" sx={{ mb: 0.5 }} />
            <Skeleton variant="rectangular" height={40} animation="wave" sx={{ borderRadius: '8px' }} />
          </Grid>
        ))}

        {/* Contact Details Section */}
        <Grid item xs={12} sx={{ mt: 2 }}>
          <Skeleton variant="text" width={160} height={32} animation="wave" sx={{ mb: 1 }} />
          <Divider sx={{ mb: 1 }} />
        </Grid>

        {/* Contact Fields */}
        {Array.from({ length: 4 }).map((_, idx) => (
          <Grid item xs={12} md={6} key={`contact-${idx}`}>
            <Skeleton variant="text" width={140} height={20} animation="wave" sx={{ mb: 0.5 }} />
            <Skeleton variant="rectangular" height={40} animation="wave" sx={{ borderRadius: '8px' }} />
          </Grid>
        ))}

        {/* Submit Button */}
        <Grid item xs={12} sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end' }}>
          <Skeleton variant="rectangular" width={200} height={48} animation="wave" sx={{ borderRadius: '10px' }} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProfileSkeleton;
